// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"e0ddc847","97":"74902853","572":"5fd4e038","785":"1ba9a639","822":"7c4883be"}[chunkId] + ".chunk.css";
};